module.exports = __webpack_public_path__ + "img/ip-cctvimg-1.27ad4b91.png";